import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "fixed inset-0 z-50 overflow-y-auto vue-modal-background"
};
const _hoisted_2 = {
  class: "bg-gray-50 w-full max-w-3xl shadow-lg rounded-lg mx-auto mt-24 mb-12 px-8 py-6"
};
const _hoisted_3 = {
  class: "flex items-center justify-between mb-2"
};
const _hoisted_4 = {
  class: "flex items-start bg-gray-200 rounded-lg p-6 gap-6"
};
const _hoisted_5 = {
  class: "flex flex-col items-start w-5/12 pt-1"
};
const _hoisted_6 = {
  class: "flex flex-col w-7/12"
};
const _hoisted_7 = {
  class: "flex justify-center"
};
const _hoisted_8 = {
  class: "pt-4 flex justify-end gap-3"
};
import ColorPicker from '@/components/ColorPicker.vue';
import { reactive } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { useInvoiceEmailStore } from './useInvoiceEmailStore.js';
export default {
  __name: 'UpdateButtonColorModal',
  props: {
    state: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const pickerState = reactive({
      buttonColor: props.state.buttonColor || '#000000'
    });
    const invoiceEmailStore = useInvoiceEmailStore();
    function save() {
      invoiceEmailStore.toggleButtonColorChangeModal();
      props.state.buttonColor = pickerState.buttonColor;
    }
    function close() {
      invoiceEmailStore.toggleButtonColorChangeModal();
    }
    function colorChange(colors) {
      pickerState.buttonColor = colors?.hex || colors;
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "text-left font-extrabold text-2xl"
      }, "Button Color", -1)), (_openBlock(), _createElementBlock("svg", {
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => close(), ["prevent"])),
        width: "20",
        height: "20",
        class: "cursor-pointer",
        viewBox: "0 0 16 16",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }, [...(_cache[3] || (_cache[3] = [_createElementVNode("g", {
        transform: "translate(2.000000, 2.000000)",
        stroke: "#242020"
      }, [_createElementVNode("path", {
        d: "M0.24,0.24 L11.76,11.76",
        "stroke-width": "2"
      }), _createElementVNode("path", {
        d: "M0.24,0.24 L11.76,11.76",
        "stroke-width": "2",
        transform: "translate(6.000000, 6.000000) scale(-1, 1) translate(-6.000000, -6.000000) "
      })], -1)]))]))]), _cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "pb-4 text-base text-left text-gray-900"
      }, " Modify the color of your payment button to be more inline with your brand colors. ", -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "text-sm font-semibold text-gray-700 mb-3"
      }, " Default Color ", -1)), _createElementVNode("div", {
        class: "py-2 px-6 mb-3 rounded text-white text-center text-sm font-medium cursor-pointer w-40",
        style: _normalizeStyle({
          backgroundColor: pickerState.buttonColor
        })
      }, " Pay ", 4), _createElementVNode("div", {
        class: "py-2 px-6 rounded text-white text-center text-sm font-medium cursor-pointer w-40",
        style: _normalizeStyle({
          backgroundColor: pickerState.buttonColor
        })
      }, " Pay Balance ", 4)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(ColorPicker, {
        colors: pickerState.buttonColor,
        onColorPicked: colorChange
      }, null, 8, ["colors"])])])]), _createElementVNode("div", _hoisted_8, [_createVNode(LlSecondaryButton, {
        class: "px-10",
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => close(), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" Cancel ", -1)]))]),
        _: 1
      }), _createVNode(LlSecondaryButton, {
        color: "primary",
        class: "px-10",
        onClick: _cache[2] || (_cache[2] = _withModifiers($event => save(), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" Save ", -1)]))]),
        _: 1
      })])])]);
    };
  }
};